import * as PIXI from 'pixi.js'

import { getTextureFromProps, applyDisplayObjectProps } from '../utils/props'
import TYPES from '../utils/types'

export const Sprite = (root, props) => {
  const $sprite = new PIXI.Sprite()

  $sprite.applyProps = (instance, oldProps, newProps) => {
    const { image, texture, ...props } = newProps

    if ((texture && texture !== oldProps.texture) || (image && image !== oldProps.image)) {
      instance.texture = getTextureFromProps('Sprite', newProps)
      if (typeof props.onTextureUpdate === 'function') {
        props.onTextureUpdate()
      }
    }

    applyDisplayObjectProps(instance, oldProps, props)
  }

  return $sprite
}

export default TYPES.Sprite
